import axios from "./axiosInstance";
import {
  ExpenseApiResponse,
  ExpenseDetailsApiResponse,
  ExpenseCreatePayload,
  ExpenseUpdatePayload,
  ExpenseSearchParams,
  PaginatedExpenseApiResponse
} from "../types/expenseTypes";

/**
 * Create a new expense
 */
export const createExpense = async (payload: ExpenseCreatePayload): Promise<ExpenseApiResponse> => {
  const response = await axios.post<ExpenseApiResponse>("/expenses", payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/**
 * Search expenses with optional parameters
 */
export const getAllExpenses = async (params: ExpenseSearchParams): Promise<PaginatedExpenseApiResponse> => {
  const response = await axios.get<PaginatedExpenseApiResponse>("/expenses", { params: { ...params} });
  return response.data;
};

/**
 * Fetch a specific expense by ID
 */
export const getExpenseById = async (expenseId: string): Promise<ExpenseDetailsApiResponse> => {
  const response = await axios.get<ExpenseDetailsApiResponse>(`/expenses/${expenseId}`);
  return response.data;
};

/**
 * Update an existing expense
 */
export const updateExpense = async (expenseId: string, payload: ExpenseUpdatePayload): Promise<ExpenseApiResponse> => {
  const response = await axios.post<ExpenseApiResponse>(`/expenses/${expenseId}/update`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/**
 * Delete an expense
 */
export const deleteExpense = async (expenseId: string): Promise<ExpenseApiResponse> => {
  const response = await axios.delete<ExpenseApiResponse>(`/expenses/${expenseId}`);
  return response.data;
};